'use strict'
import axios from 'axios'
const sessionURL = process.env.VUE_APP_SESSION_URL

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

axios.create(config)

axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (sessionStorage.getItem('openid') == null || sessionStorage.getItem('openid') == "" || sessionStorage.getItem('openid') == undefined || sessionStorage.getItem('token') == null || sessionStorage.getItem('token') == "") {
      window.location.href = sessionURL
      return
    }
    config.headers.Authorization = sessionStorage.getItem('token');
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    const res = response.data
    if (res.code === 504 || res.code === 505) {
      window.location.href = sessionURL
      return
    } else {
      return response
    }
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error)
  }
)

export default {
  install: function (app) {
    // 添加全局的方法
    app.config.globalProperties.axios = axios
    // 添加全局的方法
    app.config.globalProperties.$translate = (key) => {
      return key
    }
  }
}
